// Observe all .lazy-background elements and remove the lazy-background class
// when they are 3/4 of a screen away from intersecting with the viewport

let observer = new IntersectionObserver(
  entries => {
    for (let entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.remove('lazy-background')
        observer.unobserve(entry.target)
      }
    }
  },
  { rootMargin: '75%' },
)

for (let lazyBackgroundElement of document.querySelectorAll('.lazy-background')) {
  observer.observe(lazyBackgroundElement)
}
